var map = {
	"./avatar.svg": 15,
	"./cart.svg": 24,
	"./delete.svg": 98,
	"./dots.svg": 99,
	"./facebook.svg": 100,
	"./google.svg": 101,
	"./instagram.svg": 102,
	"./lock.svg": 103,
	"./mail.svg": 104,
	"./mastercard.svg": 6,
	"./name.svg": 105,
	"./paypal.svg": 7,
	"./twitter.svg": 106,
	"./visa.svg": 8,
	"./youtube.svg": 107
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17;



//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*\.svg$
// module id = 17
// module chunks = 0